import { usePermissionStore } from "./permissionStore";

export const DashboardPermissions: any = () => {
    const usePermits = (({ permissions }) => (key: string) => permissions.includes(key))(usePermissionStore());
    return {
        // DashboardPermissions
        appAll: usePermits("all"),
        appOverview: usePermits("overview"),
        appClassification: usePermits("deviceClassification"),
        appRemediation: usePermits("remediation"),
        appPolicies: usePermits("compPolicies"),
        appAccess: usePermits("conditionalAccess"),
        appSurvey: usePermits("userSurveys"),
        appCollection: usePermits("dataCollection"),

        // Devices page
        devicesAll: usePermits("all"),
        devicesOverviewFull: usePermits("overview_Fullaccess"),
        devicesOverviewRead: usePermits("overview_Read"),
        devicesOverviewReadExport: usePermits("overview_ReadandExport"),
        devicesClassificationFull: usePermits("deviceClassification_Fullaccess"),
        devicesClassificationRead: usePermits("deviceClassification_Read"),
        devicesClassificationReadExport: usePermits("deviceClassification_ReadandExport"),
        devicesMonitorFull: usePermits("monitor_Fullaccess"),
        devicesMonitorRead: usePermits("monitor_Read"),
        devicesMonitorReadExport: usePermits("monitor_ReadandExport"),
        devicesRemediationFull: usePermits("remediation_Fullaccess"),
        devicesRemediationRead: usePermits("remediation_Read"),
        devicesRemediationReadExport: usePermits("remediation_ReadandExport"),
        devicesPolicyFull: usePermits("compPolicies_Fullaccess"),
        devicesPolicyRead: usePermits("compPolicies_Read"),
        devicesPolicyReadExport: usePermits("compPolicies_ReadandExport"),
        devicesAccessFull: usePermits("conditionalAccess_Fullaccess"),
        devicesAccessRead: usePermits("conditionalAccess_Read"),
        devicesAccessReadExport: usePermits("conditionalAccess_ReadandExport"),
        devicesSurveyFull: usePermits("userSurveys_Fullaccess"),
        devicesSurveyRead: usePermits("userSurveys_Read"),
        devicesSurveyReadExport: usePermits("userSurveys_ReadandExport"),
        devicesCollectionFull: usePermits("dataCollection_Fullaccess"),
        devicesCollectionRead: usePermits("dataCollection_Read"),
        devicesCollectionReadExport: usePermits("dataCollection_ReadandExport"),
        devicesLogFull: usePermits("activityLog_Fullaccess"),
        devicesLogRead: usePermits("activityLog_Read"),
        devicesLogReadExport: usePermits("activityLog_ReadandExport"),

        // Patch page
        patchAll: usePermits("all"),
        patchRead: usePermits("patchDetection_Read"),
        patchFull: usePermits("patchDetection_Fullaccess"),
        patchReadExport: usePermits("patchDetection_ReadandExport"),
        
        // Apps page
        appsAll: usePermits("all"),
        appsFull: usePermits("discoverApps_Fullaccess"), /** @TODO : Need to remove full-access in discover apps... */
        appsRead: usePermits("discoverApps_Read"),
        appsReadExport: usePermits("discoverApps_ReadandExport"),
        appsInstallFull: usePermits("appInstall_Fullaccess"),
        appsInstallRead: usePermits("appInstall_Read"),
        appsInstallReadExport: usePermits("appInstall_ReadandExport"),
        appsUninstallFull: usePermits("appUnInstall_Fullaccess"),
        appsUninstallRead: usePermits("appUnInstall_Read"),
        appsUninstallReadExport: usePermits("appUnInstall_ReadandExport"),
        appsStatusFull: usePermits("appStatus_Fullaccess"),
        appsStatusRead: usePermits("appStatus_Read"),
        appsStatusReadExport: usePermits("appStatus_ReadandExport"),
        appsMonitorFull: usePermits("appMonitored_Read"),
        appsMonitorRead: usePermits("appMonitored_Fullaccess"),
        appsMonitorReadExport: usePermits("appMonitored_ReadandExport"),
        appsInstallationFull: usePermits("appInstallation_Read"),
        appsInstallationRead: usePermits("appInstallation_ReadandExport"),
        appsInstallationReadExport: usePermits("appInstallation_Fullaccess"),
        appsUnInstallationFull: usePermits("appUnInstallProfile_Read"),
        appsUnInstallationRead: usePermits("appUnInstallProfile_ReadandExport"),
        appsUnInstallationReadExport: usePermits("appUnInstallProfile_Fullaccess"),
        appsProtectFull: usePermits("appProtectProfile_Fullaccess"),
        appsProtectRead: usePermits("appProtectProfile_Read"),
        appsProtectReadExport: usePermits("appProtectProfile_ReadandExport"),
        // appsLogFull: usePermits("appLog_Fullaccess"), //need to remove full-access in app log.
        appsLogRead: usePermits("appLog_Read"),
        appsLogReadExport: usePermits("appLog_ReadandExport"),

        // TroubleshootP page
        troubleshootAll: usePermits("all"),
        troubleshootFull: usePermits("tshoot_Fullaccess"),
        troubleshootRead: usePermits("tshoot_Read"),
        troubleshootReadExport: usePermits("tshoot_ReadandExport"),
        troubleshootAlertFull: usePermits("tshootAlert_Fullaccess"),
        troubleshootAlertRead: usePermits("tshootAlert_Read"),
        troubleshootAlertReadExport: usePermits("tshootAlert_ReadandExport"),
        troubleshootComplianceRead: usePermits("tshoot_compliancepolicy_Read"),
        troubleshootComplianceFull: usePermits("tshoot_compliancepolicy_Fullaccess"),
        troubleshootComplianceReadExport: usePermits("tshoot_compliancepolicy_ReadandExport"),
        troubleshootStatus: usePermits("status_Read"),
        troubleshootStatusRead: usePermits("status_ReadandExport"),
        troubleshootStatusFull: usePermits("status_Fullaccess"),

        // Search page
        searchAll: usePermits("all"),
        searchRead: usePermits("overview_Read"),
        searchFull: usePermits("overview_Fullaccess"),
        searchReadExport: usePermits("overview_ReadandExport"),
        searchAssetRead: usePermits("asset_Read"),
        searchAssetFull: usePermits("asset_Fullaccess"),
        searchAssetReadExport: usePermits("asset_ReadandExport"),
        searchEventRead: usePermits("event_Read"),
        searchEventFull: usePermits("event_Fullaccess"),
        searchEventReadExport: usePermits("event_ReadandExport"),
        searchClassificationFull: usePermits("deviceClassification_Fullaccess"),
        searchClassificationRead: usePermits("deviceClassification_Read"),
        searchClassificationReadExport: usePermits("deviceClassification_ReadandExport"),

        // Administration page
        adminAll: usePermits("all"),
        adminFullAccess: usePermits("administration_Fullaccess"),
        adminRead: usePermits("administration_Read"),
        adminReadExport: usePermits("administration_ReadandExport"),
        adminUsersRead: usePermits("allUsers_Read"),
        adminUsersReadExport: usePermits("allUsers_ReadandExport"),
        adminUsersFull: usePermits("allUsers_Fullaccess"),
        adminLogRead: usePermits("administrationLog_Read"),
        adminLogFull: usePermits("administrationLog_Fullaccess"),
        adminLogReadExport: usePermits("administrationLog_ReadandExport"),
        adminActivityLog: usePermits("activityLog_Read"),
        adminActivityFull: usePermits("activityLog_Fullaccess"),
        adminActivityReadExport: usePermits("activityLog_ReadandExport"),

        // Automations page
        automationAll: usePermits("all"),
        automationFull: usePermits("allAutomation_Fullaccess"),
        automationRead: usePermits("allAutomation_Read"),
        automationReadExport: usePermits("allAutomation_ReadandExport"),
        automationConfigurationFull: usePermits("configuration_Fullaccess"),
        automationConfigurationRead: usePermits("configuration_Read"),
        automationConfigurationReadExport: usePermits("configuration_ReadandExport"),
        automationSelfFull: usePermits("selfHelp_Fullaccess"),
        automationSelfRead: usePermits("selfHelp_Read"),
        automationSelfReadExport: usePermits("selfHelp_ReadandExport"),
        automationAutoFull: usePermits("autoheal_Fullaccess"),
        automationAutoRead: usePermits("autoheal_Read"),
        automationAutoReadExport: usePermits("autoheal_ReadandExport"),
        automationScheduleFull: usePermits("automationSchedule_Fullaccess"),
        automationScheduleRead: usePermits("automationSchedule_Read"),
        automationScheduleReadExport: usePermits("automationSchedule_ReadandExport"),
        automationSurveyFull: usePermits("automationUserSurveys_Fullaccess"),
        automationSurveyRead: usePermits("automationUserSurveys_Read"),
        automationSurveyReadExport: usePermits("automationUserSurveys_ReadandExport"),
        automationAlertFull: usePermits("alert_Fullaccess"),
        automationAlertRead: usePermits("alert_Read"),
        automationAlertReadExport: usePermits("alert_ReadandExport"),
        automationLogFull: usePermits("automationLog_Fullaccess"),
        automationLogRead: usePermits("automationLog_Read"),
        automationLogReadExport: usePermits("automationLog_ReadandExport"),

        // Security page
        securityAll: usePermits("all"),
        securityPolicyFull: usePermits("security_compliancepolicy_Fullaccess"),
        securityPolicyRead: usePermits("security_compliancepolicy_Read"),
        securityPolicyReadExport: usePermits("security_compliancepolicy_ReadandExport"),
        securityCollectionFull: usePermits("security_dataCollection_Fullaccess"),
        securityCollectionRead: usePermits("security_dataCollection_Read"),
        securityCollectionReadExport: usePermits("security_dataCollection_ReadandExport"),
        securityLogRead: usePermits("security_activityLog_Read"),
        securityLogReadExport: usePermits("security_activityLog_ReadandExport"),
        
        // SSO page
        ssoAll: usePermits("all"),
        ssoFull: usePermits("configuration_Fullaccess"),
        ssoRead: usePermits("configuration_Read"),
        ssoReadExport: usePermits("configuration_ReadandExport"),
        ssoApproveAll: usePermits("all"),
        ssoApproveFull: usePermits("approvals_Fullaccess"),
        ssoApproveRead: usePermits("approvals_Read"),
        ssoApproveReadExport: usePermits("approvals_ReadandExport")
    };
};
